module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=PE - Peru.7d22ee13.svg";